import AssignUsersToCampaignCard from "@entities/assignUsers/ui/AssignUsersToCampaignCard";
import { useUpdateBrief } from "@entities/brief/lib/hooks/useUpdateBrief";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { Col, Modal, Row } from "@shared/ui";
import { Flex, Switch } from "antd";
import { Briefcase } from "lucide-react";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";

type TeamType = "planning" | "pricing" | "operations";

interface AdminWithTeams {
  userId: string;
  firstName: string;
  lastName: string;
  role: string;
  teams: TeamType[];
}

export default function ShareCampaignModal({
  isOpen,
  onClose,
  cards,
  width
}: {
  isOpen: boolean;
  onClose?: () => void;
  cards?: TeamType[];
  width?: number;
}) {
  const { brief, briefId, isLoadingBrief } = useBriefStore();
  const { updateBrief, isUpdating } = useUpdateBrief();
  const [campaignStatus, setCampaignStatus] = useState<string>("");

  const columnWidth = cards?.length === 1 ? 24 : cards?.length === 2 ? 12 : 8;

  useEffect(() => {
    setCampaignStatus(brief?.status || "");
  }, [brief]);
  return (
    <Modal
      open={isOpen}
      onCancel={() => {
        onClose?.();
      }}
      title={
        <Flex vertical gap={5}>
          <h2>Share Campaign</h2>
          <span>Manage user access and permissions for this campaign.</span>
        </Flex>
      }
      footer={null}
      closable
      centered
      width={width || 900}
      className={styles.shareCampaignModal}
    >
      <Row gutter={[16, 16]}>
        {/* <Col span={24}>
          <Card className={styles.overallStatusCard}>
            <p>Overall Campaign Status</p>
            <Radio.Group
              buttonStyle="solid"
              optionType="button"
              className={styles.statusRadioGroup}
              value={campaignStatus}
              size="small"
              onChange={(e) => {
                setCampaignStatus(e.target.value);
              }}
            >
              <Radio.Button value="Active">Active</Radio.Button>
              <Radio.Button value="Pending">Pending</Radio.Button>
              <Radio.Button value="Closed">Closed</Radio.Button>
            </Radio.Group>
            <Flex gap={10} style={{ marginTop: 20 }} justify="flex-end">
              <Button
                type="primary"
                loading={isUpdating}
                disabled={!campaignStatus}
                onClick={() => {
                  updateBrief({
                    updatedBrief: {
                      status: campaignStatus,
                      briefId,
                      brandId: brief?.brandId,
                    },
                  });
                }}
                size="small"
              >
                Save Changes
              </Button>
            </Flex>
          </Card>
        </Col> */}
        {cards?.includes("planning") && <Col span={columnWidth} className={styles.segmentCardWrapper}>
          <AssignUsersToCampaignCard
            title="planning"
            icon={<Briefcase size={14} />}
          />
        </Col>}
        {cards?.includes("pricing") && <Col span={columnWidth} className={styles.segmentCardWrapper}>
          <AssignUsersToCampaignCard
            title="pricing"
            icon={<Briefcase size={14} />}
          />
        </Col>}
        {cards?.includes("operations") && <Col span={columnWidth} className={styles.segmentCardWrapper}>
          <AssignUsersToCampaignCard
            title="operations"
            icon={<Briefcase size={14} />}
          />
          <div className={styles.internalTeamContainer}>
            <div className={styles.internalTeamText}>
              <span className={styles.internalTeamTitle}>
                Internal Team Actions
              </span>
              <span className={styles.internalTeamDesc}>
                Ops actions on behalf of brand
              </span>
            </div>
            <Switch
              size="small"
              checked={brief?.canInternalTeamTakeOpsActionsOnBehalfOfBrand}
              onChange={(value) =>
                updateBrief({
                  updatedBrief: {
                    briefId,
                    canInternalTeamTakeOpsActionsOnBehalfOfBrand: value,
                    brandId: brief?.brandId,
                  },
                })
              }
              loading={isUpdating}
            />
          </div>
        </Col>}
      </Row>
    </Modal>
  );
}
